"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "Freitag",
    "MONDAY": "Monta",
    "SATURDAY": "Samstag",
    "SUNDAY": "Sonntag",
    "THURSDAY": "Donnerstag",
    "TUESDAY": "Dienstag",
    "WEDNESDAY": "Mittwoch",
    "and": "und",
    "day": "Tag",
    "day_one": "Tag",
    "day_other": "Tage",
    "day_plural": "Tage",
    "freeOfCharge": "Kostenlos",
    "hour_one": "Stunde",
    "hour_one_plural": "Stunden",
    "hour_other": "Stunden",
    "minute": "Minute",
    "minute_one": "Minute",
    "minute_other": "Minuten",
    "ocpiRestrictionsAfterDuration": "Nach {{minDuration}}",
    "ocpiRestrictionsBetweenDuration": "Zwischen {{minDuration}} und {{maxDuration}}",
    "ocpiRestrictionsFirstDuration": "Erste {{maxDuration}}",
    "ocpiRestrictionsKwhAbove": "Wenn der Energieverbrauch über {{minKwh}} liegt",
    "ocpiRestrictionsKwhBetween": "Bei Energieverbrauch zwischen {{minKwh}} und {{maxKwh}}",
    "ocpiRestrictionsKwhLessThan": "Bei einem Energieverbrauch von weniger als {{maxKwh}}",
    "session": "Ladevorgang",
    "theDay": "Tag",
    "theDay_one": "Tag",
    "theDay_other": "Tage",
    "theHour": "Stunde",
    "theHour_one": "Stunde",
    "theHour_other": "Stunden",
    "theMinute": "Minute",
    "theMinute_one": "Minute",
    "theMinute_other": "Minuten"
};
